module.exports = __webpack_public_path__ + "static/media/ios-close-circle.045d23e1.svg";